/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import colors from '@sportninja/common/constants/appColors'

interface SectionTitleProps {
  children: string
}

const SectionTitle = ({ children }: SectionTitleProps) => {
  return (
    <p
      css={css`
        font-size: 16px;
        font-weight: 700;
        color: ${isCanlan ? colors.CYAN_BLUE : colors.AMERICAN_YELLOW};
        text-transform: uppercase;
        margin-top: 24px;
        margin-bottom: 16px;
        font-family: ${isCanlan
          ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif'
          : 'BarlowCondensed, Arial, Helvetica, sans-serif'};
      `}
    >
      {children}
    </p>
  )
}

export default SectionTitle
